import LensIcon from '@mui/icons-material/Lens';
import { List, ListItem, ListItemButton, ListItemIcon, Checkbox, ListItemText, Button } from '@mui/material';
import React, { type FC, useMemo } from 'react';

import { type MatchingPatients } from '../../api/index.js';

interface PatientsListProps {
  patients?: MatchingPatients[];
  onToggle: (patientId: string) => void;
  checkedItems: { [key: string]: boolean };
  onApply?: () => void;
  disabledButton?: boolean;
}

const MatchingPatientsList: FC<PatientsListProps> = ({ patients, onToggle, checkedItems, onApply, disabledButton }) => {
  // order Patients List by Monitoring hour condition and alphabetically
  const orderedPatients: MatchingPatients[] = useMemo(() => {
    if (patients) {
      // separate array by inMonitoringHours value
      const [inMonitoringHoursPatients, notInMonitoringHoursPatients] = patients.reduce(
        (acc: Array<MatchingPatients[]>, val, i) => {
          acc[val.inMonitoringHours ? 0 : 1].push(val);
          return acc;
        },
        [[], []],
      );
      // alphabetically sorting function
      const sortFn = (a: MatchingPatients, b: MatchingPatients) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      };

      return [...inMonitoringHoursPatients.sort(sortFn), ...notInMonitoringHoursPatients.sort(sortFn)];
    }
    return [];
  }, [patients]);

  return (
    <>
      <List sx={{ width: '100%', maxWidth: 360, minWidth: 200 }}>
        {orderedPatients?.map((patient, i) => {
          const labelId = `checkbox-list-label-${patient.name}`;

          return (
            <ListItem key={`${patient.id}-${i}-${checkedItems[patient.id]}`} disablePadding>
              <ListItemButton onClick={() => onToggle(patient.id)} dense>
                <ListItemIcon
                  sx={{
                    minWidth: 'initial',
                  }}
                >
                  <Checkbox
                    edge="start"
                    checked={checkedItems[patient.id]}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={patient.name} />
                <ListItemIcon
                  sx={{
                    minWidth: 'initial',
                  }}
                >
                  <LensIcon color={patient.inMonitoringHours ? 'success' : 'error'} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      {onApply ? (
        <Button variant="contained" disableElevation disabled={disabledButton} onClick={onApply}>
          Apply
        </Button>
      ) : null}
    </>
  );
};

export default MatchingPatientsList;
